const state = {
  position: {
    right: 60,
    bottom: 60,
  },
}

const mutations = {
  UPDATE_POSITION(state, position) {
    state.position = position
  },
}

export default {
  namespaced: true,
  state,
  mutations,
}
